angular.module('inspinia').directive('baseInput', () => {
  return {
    restrict: 'E',
    scope: {
      autocomplete: '@',
      counter: '@',
      class: '@',
      formName: '@',
      kind: '@',
      list: '@',
      max: '@',
      maxLengthErrorMessage: '@',
      min: '@',
      name: '@',
      ngDisabled: '=?',
      duplicateValidationRule: '=?',
      regexValidationRule: '=?',
      ngMaxlength: '@',
      ngMinlength: '@',
      ngModel: '=',
      ngRequired: '@',
      ngTrim: '@',
      ngValue: '@',
      placeholder: '@',
      step: '@',
      type: '@',
      duplicateErrorMessage: '@',
      // 重複をチェック行うための比較対象の配列をセット
      checkDuplicateArray: '@',
      ngChange: '&',
      ngBlur: '&',
    },
    templateUrl: `/manage/src/view/directive/base_input.html?${new Date().getTime()}`,
    transclude: true,
    link: ($scope) => {
      $scope.autocomplete = $scope.autocomplete || 'off';
      if ($scope.formName && $scope.name) {
        $scope.form = $scope.$parent[$scope.formName][$scope.name];
      }
      $scope.placeholder = $scope.placeholder || '';
      $scope.step = $scope.step || 1;
      $scope.duplicateValidationRule = $scope.duplicateValidationRule || { items: [], message: '', value: '' };
      $scope.regexValidationRule = $scope.regexValidationRule || { regex: undefined, message: '' };
      $scope.formName = $scope.formName || 'myForm';
      $scope.list = $scope.list || '';
      $scope.max = $scope.max || 0;
      $scope.maxLengthErrorMessage = $scope.maxLengthErrorMessage || false;
      $scope.min = $scope.min || 0;
      $scope.ngDisabled = $scope.ngDisabled || false;
      $scope.ngMaxlength = $scope.ngMaxlength || false;
      $scope.ngMinlength = $scope.ngMinlength || false;
      $scope.ngRequired = $scope.ngRequired || false;
      $scope.ngTrim = $scope.ngTrim || true;

      /**
       * CSSのクラス名を返す
       */
      $scope.baseInputClasses = () => {
        if ($scope.kind === 'alert') {
          return 'anglrC-inputText--alert';
        }
        if ($scope.ngDisabled) {
          return 'anglrC-inputText--disabled';
        }
        return '';
      };

      /**
       * Inputのtype属性を返す
       */
      $scope.baseInputTypes = () => {
        // TODO: type: passwordの作成
        return $scope.type === 'number' ? 'number' : 'text';
      };

      /**
       * Inputの状態を変更する
       */
      const switchInputStatus = (isInvalid) => {
        $scope.kind = isInvalid ? 'alert' : '';
        $scope.baseInputClasses();
      };

      /**
       * カウンターを表示するかどうか
       */
      $scope.showCounter = () => {
        return $scope.counter;
      };

      /**
       * カウンターのクラス
       */
      $scope.inputTextCounterClasses = () => {
        return {
          'inputTextCounter--success': $scope.textCount() <= parseInt($scope.ngMaxlength, 10),
          'inputTextCounter--error': $scope.textCount() > parseInt($scope.ngMaxlength, 10),
        };
      };

      /**
       * カウンターのクラス
       * 設定した文字数の上限値に合わせてクラスを付与する
       */
      $scope.inputTextCounterLimitClasses = () => {
        if (!$scope.counter) return '';
        if ($scope.ngMaxlength <= 9) {
          return 'inputTextCounter--1digitLimit';
        }
        if ($scope.ngMaxlength >= 10 && $scope.ngMaxlength <= 99) {
          return 'inputTextCounter--2digitLimit';
        }
        if ($scope.ngMaxlength >= 100 && $scope.ngMaxlength <= 999) {
          return 'inputTextCounter--3digitLimit';
        }
        if ($scope.ngMaxlength >= 1000) {
          console.error('styleを付与できません。1000文字以下で設定してください');
        }
        return '';
      };

      /**
       * 最大文字列を表示するかどうか
       */
      $scope.showMaxLength = () => {
        return Boolean($scope.ngMaxlength);
      };

      /**
       * 最大文字列バリデーションメッセージを表示するかどうか
       */
      $scope.showMaxLengthValidationMessage = () => {
        if (!$scope.maxLengthErrorMessage || !$scope.form || !$scope.form.$error || !$scope.name) return false;
        if (!$scope.ngMaxlength) throw new Error('ngMaxlengthを指定してください');
        return $scope.form.$error.maxlength && $scope.form.$dirty;
      };

      /**
       * 入力された文字数をカウント
       */
      $scope.textCount = () => {
        if ($scope.showMaxLengthValidationMessage()) return $scope.form.$viewValue.length;
        return $scope.ngModel ? $scope.ngModel.length : 0;
      };

      /**
       * 最小値バリデーションの判定
       */
      const checkMinValidate = () => {
        return Number($scope.ngModel) < Number($scope.min);
      };

      /**
       * 最小値バリデーションメッセージを表示するかどうか
       */
      $scope.showMinValidationMessage = () => {
        if (
          $scope.ngModel === undefined ||
          !$scope.form ||
          !$scope.form.$error ||
          !$scope.name ||
          $scope.form.$name !== $scope.name
        ) {
          return false;
        }

        const isInvalid = checkMinValidate();
        $scope.form.$invalid = isInvalid;
        $scope.form.$error.min = isInvalid;
        return isInvalid;
      };

      /**
       * 最大値バリデーションの判定
       */
      const checkMaxValidate = () => {
        return Number($scope.ngModel) > Number($scope.max);
      };

      /** 最大値のバリデーションメッセージを表示するかどうか */
      $scope.showMaxValidationMessage = () => {
        if (
          $scope.ngModel === undefined ||
          !$scope.form ||
          !$scope.form.$error ||
          !$scope.name ||
          $scope.form.$name !== $scope.name
        ) {
          return false;
        }

        const isInvalid = checkMaxValidate();
        $scope.form.$invalid = isInvalid;
        $scope.form.$error.max = isInvalid;
        return isInvalid;
      };

      /**
       * 必須項目バリデーションメッセージを表示するかどうか
       */
      $scope.showRequiredValidationMessage = () => {
        if (!$scope.ngRequired || !$scope.form || !$scope.form.$error || !$scope.name) return false;
        return $scope.form.$error.required && $scope.form.$dirty;
      };

      /**
       * 文字列の重複バリデーションの判定
       */
      const checkDuplicateValidate = () => {
        if (!$scope.duplicateValidationRule || !$scope.duplicateValidationRule.items) return false;
        return $scope.duplicateValidationRule.items.includes($scope.duplicateValidationRule.value);
      };

      /**
       * 正規表現バリデーションの判定
       */
      const checkRegexValidate = () => {
        if (!$scope.regexValidationRule || !$scope.regexValidationRule.regex) return false;
        return !$scope.regexValidationRule.regex.test($scope.ngModel);
      };

      /**
       * 正規表現バリデーションメッセージを表示するかどうか
       */
      $scope.showRegexValidateMessage = () => {
        if (
          $scope.ngModel === undefined ||
          !$scope.form ||
          !$scope.form.$error ||
          !$scope.name ||
          $scope.form.$name !== $scope.name
        ) {
          return false;
        }

        const isInvalid = checkRegexValidate();
        $scope.form.$invalid = isInvalid;
        $scope.form.$error.regex = isInvalid;
        return isInvalid;
      };

      /**
       * 文字列の重複バリデーションメッセージを表示するかどうか
       */
      $scope.showDuplicateValidationMessage = () => {
        if (
          !$scope.duplicateValidationRule ||
          !$scope.duplicateValidationRule.message ||
          !$scope.ngModel ||
          !$scope.name ||
          $scope.form.$name !== $scope.name
        ) {
          return false;
        }
        const isInvalid = checkDuplicateValidate();
        $scope.form.$error.duplicate = isInvalid;
        $scope.form.$invalid = isInvalid;
        return $scope.form.$error.duplicate && $scope.form.$dirty;
      };

      /**
       * ngChangeイベントの発火
       */
      $scope.onChangeBaseInput = () => {
        const setValue = () => {
          if (!$scope.ngDisabled) $scope.ngChange();

          $scope.$watch('form.$invalid', (isInvalid) => {
            switchInputStatus(isInvalid);
          });
        };
        setTimeout(setValue, 100);
      };
    },
  };
});
